import { useParams } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { PostsList } from "@/components/posts/PostsList";
import { Hash } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const HashtagPage = () => {
  const { tag } = useParams();

  const { data: hashtag } = useQuery({
    queryKey: ['hashtag', tag],
    queryFn: async () => {
      if (!tag) return null;
      
      const { data, error } = await supabase
        .from('hashtags')
        .select('*')
        .eq('name', tag)
        .single();

      if (error && error.code !== 'PGRST116') throw error;
      return data;
    },
    enabled: !!tag,
  });

  const { data: posts } = useQuery({
    queryKey: ['hashtag-posts', tag],
    queryFn: async () => {
      if (!tag) return [];

      const { data: hashtagData } = await supabase
        .from('hashtags')
        .select('id')
        .eq('name', tag)
        .single();

      if (!hashtagData) return [];

      const { data: postHashtags } = await supabase
        .from('post_hashtags')
        .select('post_id')
        .eq('hashtag_id', hashtagData.id);

      if (!postHashtags?.length) return [];

      const postIds = postHashtags.map(ph => ph.post_id);
      
      const { data, error } = await supabase
        .from('posts')
        .select(`
          *,
          profiles!posts_user_id_fkey (username, avatar_url),
          comments (
            id,
            content,
            user_id,
            created_at,
            profiles!comments_user_id_fkey (username, avatar_url)
          )
        `)
        .in('id', postIds)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as any[];
    },
    enabled: !!tag,
  });

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Hash className="w-8 h-8 text-primary" />
          <div>
            <h1 className="text-3xl font-bold">#{tag}</h1>
            {hashtag && (
              <p className="text-muted-foreground">
                {hashtag.usage_count} post{hashtag.usage_count !== 1 ? 's' : ''}
              </p>
            )}
          </div>
        </div>

        <PostsList posts={posts || []} isLoading={false} />
      </div>
    </Layout>
  );
};